var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "table unit_group", staticStyle: { "overflow-x": "auto" } },
    _vm._l(_vm.rowText, function (row, rowIndex) {
      return _c(
        "div",
        {
          directives: [
            { name: "pui-form-grid-row", rawName: "v-pui-form-grid-row" },
          ],
          key: rowIndex,
          staticClass: "row",
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "pui-form-grid-column",
                  rawName: "v-pui-form-grid-column",
                  value: 1,
                  expression: "1",
                },
              ],
              staticStyle: { "min-width": "100px" },
            },
            [_vm._v(" " + _vm._s(row) + " ")]
          ),
          _vm._l(_vm.data, function (col, colIndex) {
            return _c(
              "div",
              {
                directives: [
                  {
                    name: "pui-form-grid-column",
                    rawName: "v-pui-form-grid-column",
                    value: 1,
                    expression: "1",
                  },
                ],
                key: colIndex,
              },
              [
                _c(
                  "div",
                  {
                    key: _vm.flagMaterials,
                    attrs: {
                      title: col.sourceBlockNameSid
                        ? _vm.$t(
                            `operationalData.entryView.tabs.dropDownOptions.${col.sourceBlockNameSid}`
                          )
                        : _vm.$t("placeholder"),
                    },
                  },
                  [
                    rowIndex == 1
                      ? _c("pui-form-select", {
                          staticClass: "materials_input mt-1 mb-1",
                          attrs: {
                            label: "Material",
                            id: "materialsBuildingBlockName-" + colIndex,
                            options: _vm.options,
                            "search-input-placeholder": _vm.$t("placeholder"),
                            "is-valid": _vm.isValidName(col),
                            "is-disabled": _vm.isReadOnly,
                          },
                          on: { change: _vm.atInputChange },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (slotProps) {
                                  return [
                                    _c("pui-list-option", {
                                      staticClass: "dropDown_options",
                                      attrs: {
                                        label: slotProps.option.label,
                                        title: slotProps.option.label,
                                      },
                                    }),
                                  ]
                                },
                              },
                            ],
                            null,
                            true
                          ),
                          model: {
                            value: col.sourceBlockNameSid,
                            callback: function ($$v) {
                              _vm.$set(col, "sourceBlockNameSid", $$v)
                            },
                            expression: "col.sourceBlockNameSid",
                          },
                        })
                      : _vm._e(),
                  ],
                  1
                ),
                rowIndex == 2
                  ? _c("custom-input", {
                      staticClass: "materials_input mt-1 mb-1",
                      attrs: {
                        precision: _vm.precision,
                        min: _vm.min,
                        required: false,
                        "is-disabled": _vm.isReadOnly,
                        readonly: _vm.isReadOnly,
                      },
                      on: { change: _vm.atInputChange },
                      model: {
                        value: col.stock,
                        callback: function ($$v) {
                          _vm.$set(col, "stock", _vm._n($$v))
                        },
                        expression: "col.stock",
                      },
                    })
                  : _vm._e(),
                rowIndex == 3
                  ? _c("custom-input", {
                      staticClass: "materials_input mt-1 mb-1",
                      attrs: {
                        precision: _vm.precision,
                        min: _vm.min,
                        required: false,
                        "is-disabled": _vm.isReadOnly,
                        readonly: _vm.isReadOnly,
                      },
                      on: { change: _vm.atInputChange },
                      model: {
                        value: col.additions,
                        callback: function ($$v) {
                          _vm.$set(col, "additions", _vm._n($$v))
                        },
                        expression: "col.additions",
                      },
                    })
                  : _vm._e(),
                rowIndex == 4
                  ? _c("custom-input", {
                      staticClass: "materials_input mt-1 mb-1",
                      attrs: {
                        precision: _vm.precision,
                        min: _vm.min,
                        required: false,
                        "is-disabled": _vm.isReadOnly,
                        readonly: _vm.isReadOnly,
                      },
                      on: { change: _vm.atInputChange },
                      model: {
                        value: col.disposal,
                        callback: function ($$v) {
                          _vm.$set(col, "disposal", _vm._n($$v))
                        },
                        expression: "col.disposal",
                      },
                    })
                  : _vm._e(),
                rowIndex == 0 && colIndex != 0
                  ? _c("pui-lightbox", {
                      ref: "confirmDeletionModalRef",
                      refInFor: true,
                      staticClass: "modal",
                      attrs: {
                        state: "secondary",
                        "default-header-label": _vm.$t(
                          "operationalData.entryView.tabs.thermalGen.confirmDeletionPopupHeader"
                        ),
                        "fit-content": true,
                        fullscreen: false,
                        "close-on-overlay-click": true,
                      },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "lightbox-trigger",
                            fn: function () {
                              return [
                                _c("pui-button", {
                                  staticClass: "button__delete",
                                  attrs: {
                                    "icon-only": true,
                                    icon: "delete",
                                    disabled: _vm.isReadOnly,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.openConfirmDeletionPopup(
                                        colIndex
                                      )
                                    },
                                  },
                                }),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "default",
                            fn: function () {
                              return [
                                _c("div", { staticClass: "mt-3 mb-3" }, [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "operationalData.entryView.tabs.thermalGen.confirmDeletionPopupText"
                                        )
                                      ) +
                                      " "
                                  ),
                                ]),
                              ]
                            },
                            proxy: true,
                          },
                          {
                            key: "lightbox-footer",
                            fn: function () {
                              return [
                                _c(
                                  "pui-button",
                                  {
                                    attrs: { state: "secondary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.deleteColumn(colIndex)
                                      },
                                    },
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.$t(
                                            "defaultValidityModalConfirmLabel"
                                          )
                                        ) +
                                        " "
                                    ),
                                  ]
                                ),
                                _c(
                                  "pui-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.closeConfirmDeletionPopup(
                                          colIndex
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v(" " + _vm._s(_vm.$t("cancel")) + " ")]
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ],
                        null,
                        true
                      ),
                    })
                  : _vm._e(),
                rowIndex == 0 && colIndex == 0
                  ? _c("div", { staticStyle: { width: "200px" } })
                  : _vm._e(),
              ],
              1
            )
          }),
          rowIndex == 1
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: 1,
                      expression: "1",
                    },
                  ],
                },
                [
                  _vm.data.length < _vm.maxBuildingBlocksCount
                    ? _c(
                        "pui-button",
                        {
                          attrs: {
                            id: "addSourceButton",
                            disabled: _vm.isReadOnly,
                          },
                          on: { click: _vm.addColumn },
                        },
                        [
                          _c("pui-icon", { attrs: { "icon-name": "add" } }),
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$t(
                                  "operationalData.entryView.tabs.thermalGen.addSource"
                                )
                              ) +
                              " "
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          rowIndex > 1
            ? _c(
                "div",
                {
                  directives: [
                    {
                      name: "pui-form-grid-column",
                      rawName: "v-pui-form-grid-column",
                      value: 1,
                      expression: "1",
                    },
                  ],
                },
                [_vm._v(" t ")]
              )
            : _vm._e(),
        ],
        2
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }